// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__8BtPO","content":"not-found_content__gf-Hy","text":"not-found_text__Rj0VL"};